// extracted by mini-css-extract-plugin
export default {"productGrid":"i0-z","centerLink":"j0-z","productSection":"k0-z","item":"l0-z","ctaButton":"m0-z"};